<template>
    <div class="mt-2">
        <div v-if="photos.length" class="grid grid-cols-5 gap-1">
            <a
                v-for="photo in photos.slice(0, count)"
                :key="photo.id"
                :href="`/photos`"
                class="home-photo-cell group relative block aspect-square overflow-hidden rounded"
            >
                <img
                    :src="photo.url"
                    :alt="photo.description || `Photo taken ${photo.takenAt}`"
                    loading="lazy"
                    class="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span
                    v-if="photo.takenAt"
                    class="absolute inset-x-0 bottom-0 truncate bg-black/60 px-1 py-px text-[10px] leading-tight text-slate-200"
                >
                    {{ formatDate(photo.takenAt, 'M/D/YY') }}
                </span>
            </a>
        </div>
        <div
            v-else
            class="flex h-24 w-full flex-wrap items-center justify-center text-center text-slate-400"
        >
            No Photos Yet.
        </div>
    </div>
</template>

<script>
import { formatDate } from '@/utils/Utilities';
import { gsap } from 'gsap/all';

export default {
    name: 'HomeLatestPhotos',
    props: {
        photos: {
            type: Array,
            default: () => [],
        },
        count: {
            type: Number,
            default: 5,
        },
    },
    mounted() {
        gsap.fromTo(
            '.home-photo-cell',
            { y: 10, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.03, duration: 0.25 },
        );
    },
    methods: {
        formatDate,
    },
};
</script>

<style lang="postcss">
.home-photo-cell {
    opacity: 0;
}
</style>
